// Full-document render of the anonymous order-lookup ("Find your order") page:
// PageSkeleton wrapping the centered status-container with the bound
// LookupOrdersAltForm (email / order number / zip) rendered through the
// reactivated widget tree so an invalid POST round-trips its validation errors.
//
// NOTE: this view (LookupOrdersAltView / oscar/customer/order-lookup.html) is
// NOT mounted in tempurpedic's URLconf -- tempurpedic wires only the unified
// (USC) order-lookup flow, never the stock `order-lookup` URL, so this page is
// unreachable. The real wrapper ships anyway (a stub would render a blank page
// if the key were ever reachable) and the ORDER_LOOKUP key is enabled for the
// empty-disabled-set end state, matching stearns. Copy resolves via ttag `t`
// so tempurca (fr_CA) stays translated.
import React from "react";
import { ReactivatedFormWidget } from "tsi-common-react/src/forms/ReactivatedFormWidget/index";
import { t } from "ttag";

import { templates } from "@reactivated";

import { CSRFToken } from "@reactivated/forms";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.OrderLookupDocumentTemplate,
): React.JSX.Element => {
    // Non-field errors land under __all__ (raised by clean() without a field).
    // Annotate as Record to allow __all__ key access.
    const formErrors: Record<string, readonly string[] | undefined> | null =
        props.form.errors;
    const nonFieldErrors = formErrors?.["__all__"] ?? null;
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <section
                id="order-lookup"
                className="order-support order-support--content-centered"
            >
                <div className="main-container">
                    <div className="detail-container">
                        <section className="status-container">
                            <h1>{t`Find your order`}</h1>
                            {props.orders_header && (
                                <p>{props.orders_header}</p>
                            )}
                            <form method="post">
                                <CSRFToken />
                                {props.form.iterator.map((name) => {
                                    const field = props.form.fields[name];
                                    const errors = formErrors?.[name];
                                    return (
                                        <div key={name}>
                                            <div className="input-container">
                                                <ReactivatedFormWidget
                                                    widget={field.widget}
                                                />
                                                <label
                                                    htmlFor={
                                                        field.widget.attrs.id
                                                    }
                                                >
                                                    {field.label}
                                                </label>
                                                {errors &&
                                                    errors.length > 0 && (
                                                        <ul className="errorlist">
                                                            {errors.map(
                                                                (error, i) => (
                                                                    <li key={i}>
                                                                        {error}
                                                                    </li>
                                                                ),
                                                            )}
                                                        </ul>
                                                    )}
                                            </div>
                                        </div>
                                    );
                                })}
                                {nonFieldErrors &&
                                    nonFieldErrors.length > 0 && (
                                        <ul className="errorlist nonfield">
                                            {nonFieldErrors.map((error, i) => (
                                                <li key={i}>{error}</li>
                                            ))}
                                        </ul>
                                    )}
                                <input
                                    className="button button--full-width"
                                    type="submit"
                                    value={t`Look Up`}
                                    id="look-up-btn"
                                />
                            </form>
                        </section>
                    </div>
                </div>
            </section>
        </PageSkeleton>
    );
};
